function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12 22.75c-5.2 0-9.42-4.23-9.42-9.42C2.58 8.14 6.8 3.9 12 3.9c1.07 0 2.11.15 3.11.46.4.12.62.54.5.94a.75.75 0 01-.94.5c-.85-.26-1.75-.4-2.67-.4-4.37 0-7.92 3.55-7.92 7.92s3.55 7.92 7.92 7.92a7.925 7.925 0 006.59-12.32.746.746 0 01.21-1.04c.34-.23.81-.14 1.04.21a9.366 9.366 0 011.59 5.24c-.01 5.19-4.23 9.42-9.43 9.42z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.13 6.07c-.21 0-.42-.09-.57-.26l-2.89-3.32a.756.756 0 01.07-1.06c.31-.27.79-.24 1.06.07l2.89 3.32c.27.31.24.79-.07 1.06-.13.13-.31.19-.49.19z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.76 8.53c-.23 0-.46-.11-.61-.31-.24-.33-.17-.8.16-1.05l3.37-2.46a.752.752 0 01.89 1.21L13.2 8.39a.7.7 0 01-.44.14z"
})));